import Fuse from 'fuse.js'

document.addEventListener("readystatechange", ev => {
    if (document.readyState === "interactive") {
        init()
    }
})


let searchTerm = " "
let lis = []
let topics = []
let filteredAnswers = []

function init() {

    buildTopicsBtns()

    filterAnswers(true)

    let inputElem = document.getElementById("question-input")
    inputElem.addEventListener("input", ev => {
        searchTerm = inputElem.value
        searchAnswers(searchTerm)
    })
    let resetBtn = document.getElementById("reset-btn")
    resetBtn.addEventListener("click", () => {
        searchTerm = ""
        topics.map(t => t.enabled = true)
        filterAnswers(true)
    })
}


function buildTopicsBtns() {
    let ul = document.getElementById("topic-list")

    answers.map((answer) => {
        if (!topics.some(topic => topic.topic === answer.topic)) {
            let topic = {
                topic: answer.topic,
                enabled: true
            }
            topics.push(topic)
        }
    })

    for (let i = 0; i < topics.length; i++) {
        let li = document.createElement("li")
        li.innerText = topics[i].topic
        li.addEventListener("click", ev => {

            topics.map(t => t.enabled = false)
            topics[i].enabled = true

            filterAnswers(false)

        })
        ul.appendChild(li)
        lis.push(li)
    }
}


function filterAnswers(isFromReset) {

    filteredAnswers = []
    answers.map((answer) => {

        let topic = topics.find(t => t.topic === answer.topic)
        if (topic.enabled || isFromReset) {
            filteredAnswers.push(answer)
        }
    })

    if (isFromReset) {
        updateTopicsBtns()
        let answerList = []
        filteredAnswers.map(ans => { answerList.push({ item: ans }) })
        updateAnswerList(answerList)
    } else {
        searchAnswers(searchTerm)
    }
}


function searchAnswers(searchTerm) {

    var options = {
        keys: ['description', 'title'],
        threshold: 0.22,
        includeScore: true,
        // includeMatches: true,
        maxPatternLength: 32,
        distance: 3000,
        tokenize: true
    };
    var fuse = new Fuse(filteredAnswers, options)

    let answerList = fuse.search(searchTerm === "" ? " " : searchTerm)
    updateTopicsBtns()
    updateAnswerList(answerList)
}


function updateTopicsBtns() {

    for (let l = 0; l < lis.length; l++) {
        lis[l].classList.remove("selected")
    }

    for (let t = 0; t < topics.length; t++) {
        if (topics[t].topic === lis[t].innerText && topics[t].enabled) {
            lis[t].classList.add("selected")
        }
    }
}


function updateAnswerList(answerList) {
    let ulelem = document.getElementById("support-results-list")
    ulelem.innerHTML = ""

    for (let i = 0; i < answerList.length; i++) {
        let ans = answerList[i].item
        //let matches = answerList[i].matches

        let li = document.createElement("li")
        li.classList.add("result")
        let h3 = document.createElement("h3")
        let p = document.createElement("p")

        h3.textContent = ans.title
        p.textContent = ans.description

        li.appendChild(h3)
        li.appendChild(p)
        ulelem.appendChild(li)
    }
}